var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('donut-chart',{attrs:{"chartData":_vm.chartData,"styles":_vm.styles,"loaded":true,"hide-legend":true,"hide-tool-tips":true}})}
var staticRenderFns = []

export { render, staticRenderFns }